<template>
  <div id="pagination"><strong>Pages:</strong>
    <template v-for="k in npages">
    <span v-if="k==cursor+1" :key="k">{{k}}</span>
    <a v-else :key="'_'+k" href="" @click="showListPage(k, $event)">{{k}}</a>
    </template>
    </div>
</template>
<script>
export default {
  props:{
    cursor: {
      type: Number,
      required: true
    },
    npages: {
      type: Number,
      required: true
    }
  },
  methods: {
    showListPage(pageNumber, evt){
      evt.preventDefault();
      this.$emit('showpage', pageNumber-1)
    }
  }

}
</script>